import { ExperiencesContainer } from "../../containers";
import "./style.scss";
function Experiences() {
  return (
    <div id="experiencesPage">
      <ExperiencesContainer />
    </div>
  );
}
export default Experiences;
